/* eslint-disable react/no-array-index-key */
import { SessionEvent } from '@/api/oversight/types';

import { describeSessionEvent } from '../../utils';
import {
  timelineDataAdmUserDelegatedAccess,
  timelineDataClient,
  timelineDataSectionsAdmUser,
  TimelineItemProps,
} from './data';
import { Container } from './styles';
import { TimelineItem } from './TimelineItem';

type TimelineProps = {
  source?: 'delegated_access' | 'section_client' | 'section_adm_user';
  events?: SessionEvent[];
  onActivityClick?: (id: number) => void;
};

const formatEventTime = (isoDate: string): string =>
  new Date(isoDate).toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  });

export function Timeline({
  source,
  events,
  onActivityClick,
}: TimelineProps): JSX.Element {
  const sourceMap = {
    delegated_access: timelineDataAdmUserDelegatedAccess,
    section_client: timelineDataClient,
    section_adm_user: timelineDataSectionsAdmUser,
  };

  const items: TimelineItemProps[] = events
    ? events.map((event) => ({
        id: event.id,
        time: formatEventTime(event.occurred_at),
        message: describeSessionEvent(event.method, event.endpoint),
        status: event.status_category === 'success' ? 'success' : 'error',
        isAuditable: event.is_auditable,
      }))
    : sourceMap[source ?? 'section_client'] || [];

  return (
    <Container>
      {items.map((item, index) => (
        <TimelineItem
          key={index}
          id={item.id}
          time={item.time}
          message={item.message}
          status={item.status}
          isLink={item.isLink}
          isFirst={index === 0}
          isLast={index === items.length - 1}
          onClick={
            item.isLink && onActivityClick
              ? () => onActivityClick(Number(item.id))
              : undefined
          }
        />
      ))}
    </Container>
  );
}
